export default __webpack_public_path__ + "twitter.383f54462943c4d92293709c31f8b476.svg";